import DefaultFooter from "./DefaultFooter";
import FrontendFooter from "./FrontendFooter";
import ReaderFooter from "./ReaderFooter";
import StandaloneFooter from "./StandaloneFooter";

export default {
  DefaultFooter,
  FrontendFooter,
  ReaderFooter,
  StandaloneFooter
};
